import React, { useRef, memo } from "react";
import { useInView } from "react-intersection-observer";
import { useDispatch, useSelector } from "react-redux";
import {
  selectInvoicingSteps,
  selectAppUser,
  selectNavigation,
} from "../store/selectors/navigation";
import { selectNewInvoices } from "../store/selectors/invoicing";

import NewTable from "../components/newTable/newTable";
import copyIco from "../copyIco.svg";
import netherlands from "../netherlands.png";
import germany from "../germany.png";
import unitedK from "../united-kingdom.png";
import { AssetsCheckbox3 } from "../components/assetsInputs";
import { setInvoicingSteps } from "../store/actions/navigation";
import {
  removeInvoice,
  submitInvoices,
  updateContractOrLines,
  submitCrediting,
} from "../store/actions/invoicing";
import { dateFormat } from "./dateConv";
import { Button } from "@mui/material";

const PanelComponent = (props) => {
  const appUser = useSelector(selectAppUser);
  const newInvoices = useSelector(selectNewInvoices);
  const headerRef = useRef();
  const headerRef2 = useRef();
  const dispatch = useDispatch();

  const invoicingSteps = useSelector(selectInvoicingSteps);
  const navigation = useSelector(selectNavigation);
  const dataLine = (desc, value, onClick) => {
    return (
      <div className="dasLine">
        <div className="dasDesc">{desc}</div>
        <div className="dasValue" onClick={onClick}>
          {value}
        </div>
      </div>
    );
  };
  const stringCut = (string, stringLength) => {
    const allParts = string.split(" ");
    let newIndex = 0;
    let newArr = [];
    for (let part of allParts) {
      if (
        `${newArr[newIndex] ? newArr[newIndex] : ""}${part} `.length >
        stringLength
      ) {
        newIndex++;
      }
      newArr[newIndex] = `${newArr[newIndex] ? newArr[newIndex] : ""}${part} `;
    }
    return newArr;
  };
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const [ref2, inView2] = useInView({
    threshold: 0,
  });

  const isInView = useInView(headerRef2);
  if (props.type === "contractSelect") {
    return (
      <NewTable
        tabletype={"big"}
        tit={"contractsSelect"}
        data={props.props}
        width={headerRef.current ? headerRef.current.clientWidth : 100}
      />
    );
  } else if (props.type === "contractInfo") {
    const contractInfoLines = (arr) => {
      return arr.map((lineA) => (
        <div className={"contractInfoLine"}>
          <div className="contractInfoLineA">
            <div className="contractInfoLineAA">{lineA[0]}</div>
            <div className="contractInfoLineAB">{lineA[1]}</div>
          </div>
          <div className="contractInfoLineB">
            <div className="contractInfoLineBA">{lineA[2]}</div>
            <div className="contractInfoLineBB">{lineA[3]}</div>
          </div>
        </div>
      ));
    };
    const contractInfoLine = (line) => {
      return (
        <div className={"contractInfoLine"}>
          <div className="contractInfoLineA">
            <div className="contractInfoLineAA">{line[0]}</div>
            <div className="contractInfoLineAB">{line[1]}</div>
          </div>
          <div className="contractInfoLineB">
            <div className="contractInfoLineBA">{line[2]}</div>
            <div className="contractInfoLineBB">{line[3]}</div>
          </div>
        </div>
      );
    };
    // if (props.props.orderLines.length > 0) {
    return (
      <div className={"invoiceContractPanel"}>
        <div className="invoiceContractHeader">
          {contractInfoLine([
            "Customer:",
            props.props.customerName,
            "Customer's Twinfield id:",
            props.props.twinfield_id,
          ])}
          {contractInfoLine([
            "User:",
            props.props.userName,
            "Contract id:",
            props.props.contract_id,
          ])}
          {contractInfoLine([
            "Agent: ",
            props.props.agentName,
            "Service id:",
            props.props.service_id,
          ])}
          {props.props.po_number ||
          props.props.discount_perc ||
          props.props.partner_fee_perc
            ? contractInfoLine([
                props.props.po_number ? "PO #:" : "",
                props.props.po_number ? props.props.po_number : "",
                props.props.discount_perc
                  ? "Partner discount:"
                  : props.props.partner_fee_perc
                    ? "Partner fee:"
                    : "",
                props.props.discount_perc
                  ? props.props.discount_perc + "%"
                  : props.props.partner_fee_perc
                    ? props.props.partner_fee_perc + "%"
                    : "",
              ])
            : ""}
        </div>
        {props.props.orderLines.length > 0 ? (
          <div className={"subContractPanel"}>
            <div className={"subContractPanelOr"}>Orderlines</div>

            <div
              className="smallTableWrapper"
              ref={headerRef}
              style={{ maxHeight: "200px" }}
            >
              <NewTable
                tit={"contractsOrderlines"}
                data={props.props.orderLines.map((orLine) => {
                  return {
                    ...orLine,
                    start_date_t: orLine.start_date_t
                      ? dateFormat(orLine.start_date_t)
                      : "-",
                    end_date_t: orLine.end_date_t
                      ? dateFormat(orLine.end_date_t)
                      : "-",
                    last_invoiced_t: orLine.last_invoiced_t
                      ? dateFormat(orLine.last_invoiced_t)
                      : "-",
                  };
                })}
                width={headerRef.current ? headerRef.current.clientWidth : 100}
              />
            </div>
            {Object.keys(props.props).length > 0 &&
            invoicingSteps.orLineEdit ? (
              <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                <Button
                  variant="contained"
                  sx={{
                    fontFamily: "Quenda, serif !important",
                    background: "#4ab217",
                    color: "white",
                  }}
                  onClick={async (e) => {
                    dispatch(
                      updateContractOrLines({
                        contractId: props.props.contract_id,
                        orderLines: props.props.orderLines.map((line) => {
                          return {
                            qlineId: line.qline_id,
                            endDate: line.end_date_t,
                            invoiceDate: line.last_invoiced_t,
                          };
                        }),
                      }),
                    );
                    dispatch(
                      setInvoicingSteps({
                        ...invoicingSteps,
                        orLineEdit: false,
                      }),
                    );
                  }}
                >
                  Confirm
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className={"subContractPanel"}>
            <div className={"subContractPanelOr"}>No Orderlines</div>
          </div>
        )}
      </div>
    );
    // } else {
    //   return (
    // <div className={"invoiceContractPanel"}>
    //   <div className="invoiceContractHeader">
    //     {contractInfoLines([
    //       [
    //         "Customer:",
    //         props.props.customerName,
    //         "Customer's Twinfield id:",
    //         props.props.twinfield_id,
    //       ],
    //       [
    //         "User:",
    //         props.props.userName,
    //         "Service id:",
    //         props.props.service_id,
    //       ],
    //       [
    //         "Agent: ",
    //         props.props.agentName,
    //         "Contract id:",
    //         props.props.contract_id,
    //       ],
    //     ])}
    //   </div>
    //   <div className={"subContractPanel"}>
    //     <div className={"subContractPanelOr"}>No Orderlines</div>
    //   </div>
    // </div>
    // );
    // }
  } else if (props.type === "contractInvoices") {
    if (props.props.length > 0) {
      return (
        <div className={"contractInvoicesPanel"}>
          <div className="invoiceGeneralHeader">Invoices</div>
          <div className="invoiceGeneralBody">
            {props.props.map((subInv, index) => {
              let subTotal = 0;
              for (let total of subInv.invoiceLines.map((line) =>
                line.item_quantity && line.item_price
                  ? parseFloat(
                      parseFloat(
                        Math.round(line.item_quantity * line.item_price * 100) /
                          100,
                      ).toFixed(2),
                    )
                  : null,
              )) {
                subTotal = subTotal + total;
              }
              return (
                <div key={index} className={"contractInvoices"}>
                  <div className="contractInvoiceDesc">
                    <div>{`Period: ${
                      subInv.description.find(
                        (line) =>
                          line.slice(0, 7) === "Periode" ||
                          line.slice(0, 8) === "Zeitraum" ||
                          line.slice(0, 6) === "Period",
                      )
                        ? subInv.description
                            .find(
                              (line) =>
                                line.slice(0, 7) === "Periode" ||
                                line.slice(0, 8) === "Zeitraum" ||
                                line.slice(0, 6) === "Period",
                            )
                            .split(": ")[1]
                        : ""
                    }
                `}</div>
                    <div>{subInv.entity}</div>
                  </div>
                  <div className="contractInvoiceDesc">
                    <div>{`Invoice number: ${subInv.invoice_number}`}</div>
                    <div>{`Invoiced on: ${dateFormat(
                      subInv.invoice_date,
                    )}`}</div>
                  </div>
                  <div className="contractInvoiceDesc">
                    {subInv.poNumber ? (
                      <div>{`PO number: ${subInv.poNumber}`}</div>
                    ) : (
                      <div></div>
                    )}
                    <div>{`Status: ${subInv.status}`}</div>
                  </div>

                  <div className="contractInvoiceDetails" ref={ref2}>
                    <div className="contractInvoiceDetailsTable">
                      <NewTable
                        tit={"contractInvoices"}
                        tabletype="small"
                        className="histTable"
                        data={[
                          ...subInv.invoiceLines
                            .map((line) => {
                              return {
                                ...line,
                                item_quantity: line.item_quantity
                                  ? parseFloat(line.item_quantity).toFixed(2)
                                  : null,
                                item_price: line.item_price
                                  ? parseFloat(line.item_price).toFixed(2)
                                  : null,
                                total:
                                  line.item_quantity && line.item_price
                                    ? parseFloat(
                                        Math.round(
                                          line.item_quantity *
                                            line.item_price *
                                            100,
                                        ) / 100,
                                      ).toFixed(2)
                                    : null,
                              };
                            })
                            .sort((a, b) => {
                              if (
                                !invoicingSteps.linesOrder.find(
                                  (line) =>
                                    parseInt(line.id) ===
                                    parseInt(`${a.item_id}`.slice(-3)),
                                )
                              ) {
                                return 1000;
                              }
                              if (
                                !invoicingSteps.linesOrder.find(
                                  (line) =>
                                    parseInt(line.id) ===
                                    parseInt(`${b.item_id}`.slice(-3)),
                                )
                              ) {
                                return -1000;
                              }
                              return (
                                parseInt(`${a.item_id}`.slice(-3)),
                                invoicingSteps.linesOrder.find(
                                  (line) =>
                                    parseInt(line.id) ===
                                    parseInt(`${a.item_id}`.slice(-3)),
                                ).order -
                                  invoicingSteps.linesOrder.find(
                                    (line) =>
                                      parseInt(line.id) ===
                                      parseInt(`${b.item_id}`.slice(-3)),
                                  ).order
                              );
                            }),
                          {
                            item_unit: "Sub total",
                            item_price: " ",
                            total: <b>{subTotal.toFixed(2)}</b>,
                          },
                          {
                            item_unit: "VAT",
                            item_price: subInv.transfer_vat ? "0%" : "21%",
                            total: subInv.transfer_vat ? (
                              <b>0</b>
                            ) : (
                              <b>{(subTotal * 0.21).toFixed(2)}</b>
                            ),
                          },
                          {
                            total: subInv.transfer_vat ? (
                              <b>{subTotal.toFixed(2)}</b>
                            ) : (
                              <b>{(subTotal * 1.21).toFixed(2)}</b>
                            ),
                          },
                        ]}
                        width={
                          headerRef.current
                            ? headerRef.current.clientWidth
                            : 100
                        }
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div className={"contractInvoicesPanel"}>
          <div className="invoiceGeneralHeader">No invoices</div>
        </div>
      );
    }
  } else if (props.invoicePreSel) {
    let iLinesTotal = 0;
    for (let line of props.invoicePreSel.invoiceLines) {
      iLinesTotal =
        iLinesTotal +
        parseFloat(
          line.item_quantity && line.item_price
            ? parseFloat(
                Math.round(line.item_quantity * line.item_price * 100) / 100,
              ).toFixed(2)
            : 0,
        );
    }

    return (
      <div
        className={
          invoicingSteps.includedInvoicesIds.includes(props.invoicePreSel.id)
            ? "invoicePreselectPanel"
            : "invoicePreselectPanel invoicePanelDisabled"
        }
      >
        <div className="invoicePreselectDescA" ref={ref}>
          {["Regular", "Credit", "Usage"].includes(
            props.invoicePreSel.invoiceLines[0].invoice_type,
          )
            ? stringCut(props.invoicePreSel.customer, 34).map((line, i) =>
                dataLine(i === 0 ? "Customer:" : "", line),
              )
            : stringCut(props.invoicePreSel.agent, 34).map((line, i) =>
                dataLine(i === 0 ? "Agent:" : "", line),
              )}
          {stringCut(`${props.invoicePreSel.twinfield_id}`, 34).map((line, i) =>
            dataLine(i === 0 ? "Twinfield id:" : "", line),
          )}
          {stringCut(
            `${props.invoicePreSel.service_id} - ${props.invoicePreSel.user}`,
            33,
          ).map((line, i) => dataLine(i === 0 ? "Service:" : "", line))}
          {stringCut(
            `${
              props.invoicePreSel.description
                .split("\n")
                .reverse()[0]
                .split(" ")[2]
            } - ${
              props.invoicePreSel.description
                .split("\n")
                .reverse()[0]
                .split(" ")[4]
            }`,
            34,
          ).map((line, i) => dataLine(i === 0 ? "Period:" : "", line))}
          {stringCut(`${props.invoicePreSel.contract_id}`, 34).map((line, i) =>
            dataLine(i === 0 ? "Contract id:" : "", line),
          )}
        </div>
        <div className="invoicePreselectLines" ref={ref}>
          {inView ? (
            <NewTable
              tit={"invoicesPreselect"}
              tabletype="small"
              className="histTable"
              data={[
                ...props.invoicePreSel.invoiceLines
                  .map((line) => {
                    return {
                      ...line,
                      item_quantity: line.item_quantity
                        ? parseFloat(line.item_quantity).toFixed(2)
                        : null,
                      item_price: line.item_price
                        ? parseFloat(line.item_price).toFixed(2)
                        : null,
                      total:
                        line.item_quantity && line.item_price
                          ? parseFloat(
                              Math.round(
                                line.item_quantity * line.item_price * 100,
                              ) / 100,
                            ).toFixed(2)
                          : null,
                    };
                  })
                  .sort((a, b) => {
                    return (
                      parseInt(`${a.item_id}`.slice(-3)),
                      invoicingSteps.linesOrder.find(
                        (line) =>
                          parseInt(line.id) ===
                          parseInt(`${a.item_id}`.slice(-3)),
                      ).order -
                        invoicingSteps.linesOrder.find(
                          (line) =>
                            parseInt(line.id) ===
                            parseInt(`${b.item_id}`.slice(-3)),
                        ).order
                    );
                  }),
                {
                  total: (
                    <b>
                      {parseFloat(Math.round(iLinesTotal * 100) / 100).toFixed(
                        2,
                      )}
                    </b>
                  ),
                },
              ]}
              width={headerRef.current ? headerRef.current.clientWidth : 100}
            />
          ) : (
            ""
          )}
        </div>
        <AssetsCheckbox3
          value={invoicingSteps.includedInvoicesIds.includes(
            props.invoicePreSel.id,
          )}
          onChangeFunc={() => {
            if (
              !invoicingSteps.includedInvoicesIds.includes(
                props.invoicePreSel.id,
              )
            ) {
              dispatch(
                setInvoicingSteps({
                  ...invoicingSteps,
                  includedInvoicesIds: [
                    ...invoicingSteps.includedInvoicesIds,
                    props.invoicePreSel.id,
                  ],
                }),
              );
            } else {
              dispatch(
                setInvoicingSteps({
                  ...invoicingSteps,
                  includedInvoicesIds: [
                    ...invoicingSteps.includedInvoicesIds.filter(
                      (id) => id !== props.invoicePreSel.id,
                    ),
                  ],
                }),
              );
            }
          }}
        />
      </div>
    );
  } else if (
    props.customer &&
    !navigation.invoicingSubmiting &&
    !props.pastInvoice
  ) {
    let invTotal = 0;
    for (let subInv of props.subInvoices) {
      let subTotal = 0;
      for (let total of subInv.invoiceLines.map((line) =>
        line.item_quantity && line.item_price
          ? parseFloat(
              parseFloat(
                Math.round(line.item_quantity * line.item_price * 100) / 100,
              ).toFixed(2),
            )
          : null,
      )) {
        subTotal = subTotal + total;
      }
      invTotal = invTotal + subTotal;
    }
    const copyStyle = (itemClass, itemId) => {
      document.getElementById(itemId).className =
        `${itemClass} invoicingCopied`;
      setTimeout(
        () => (document.getElementById(itemId).className = `${itemClass}`),
        750,
      );
    };
    return (
      <div className={"invoiceGeneralPanel"}>
        <div className="invoiceGeneralHeader">
          <div className={"invoicePreselectDescB"}>
            <div className={"invoicePreselectDesc1stLine"}>
              <div className="dasLine">
                <img
                  alt=""
                  src={
                    props.language === "nl-NL"
                      ? netherlands
                      : props.language === "en-GB"
                        ? unitedK
                        : props.language === "de-DE"
                          ? germany
                          : ""
                  }
                  className="invoicingFlag"
                  height={"20px"}
                />
                {props.agent ? props.agent : props.customer}
              </div>
              <div className="dasLine">{`Twinfield id: ${props.twinfieldId}`}</div>
            </div>
          </div>
          <div className={"invoicePreselectDescB"}>
            <div className={"invoicePreselectDesc1stLine"}>
              <div className="dasLine" ref={ref} id="generalDesc">
                {props.generalDesc}
                {props.generalDesc ? (
                  <img
                    alt=""
                    src={copyIco}
                    height={"16px"}
                    onClick={(e) => {
                      copyStyle("dasLine", "generalDesc");
                      navigator.clipboard.writeText(props.generalDesc);
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              {props.generalDesc ? (
                <div className="dasLine">{`Total: ${invTotal.toFixed(2)}`}</div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {props.subInvoices.map((subInv) => {
          let subTotal = 0;
          for (let total of subInv.invoiceLines.map((line) =>
            line.item_quantity && line.item_price
              ? parseFloat(
                  parseFloat(
                    Math.round(line.item_quantity * line.item_price * 100) /
                      100,
                  ).toFixed(2),
                )
              : null,
          )) {
            subTotal = subTotal + total;
          }
          return (
            <div className={"subInvoicePanel"}>
              <div className={"invoicePreselectDescA"} id={subInv.description}>
                {subInv.description.split("\n").map((descLine, index) => {
                  if (index === subInv.description.split("\n").length - 1) {
                    return (
                      <p>
                        {descLine}
                        <img
                          src={copyIco}
                          height={"16px"}
                          alt=""
                          onClick={(e) => {
                            copyStyle(
                              "invoicePreselectDescA",
                              subInv.description,
                            );
                            navigator.clipboard.writeText(subInv.description);
                          }}
                        />
                      </p>
                    );
                  } else {
                    return <p>{descLine}</p>;
                  }
                })}
              </div>
              <div className="invoicePreselectLines" ref={headerRef}>
                <NewTable
                  tit={"invoicesPreselect"}
                  tabletype="small"
                  className="histTable"
                  data={[
                    ...subInv.invoiceLines
                      .map((line) => {
                        return {
                          ...line,
                          copy: (
                            <img
                              src={copyIco}
                              height={"16px"}
                              alt=""
                              onClick={(e) => {
                                copyStyle(
                                  "MuiTableCell-root MuiTableCell-body MuiTableCell-alignLeft MuiTableCell-sizeMedium elipsisRow css-c4wihh-MuiTableCell-root",
                                  `${line.qt_line_id}${line.item_description}`,
                                );
                                navigator.clipboard.writeText(
                                  line.item_description,
                                );
                              }}
                            />
                          ),
                          item_quantity: line.item_quantity
                            ? parseFloat(line.item_quantity).toFixed(2)
                            : null,
                          item_price: line.item_price
                            ? parseFloat(line.item_price).toFixed(2)
                            : null,
                          total:
                            line.item_quantity && line.item_price
                              ? parseFloat(
                                  Math.round(
                                    line.item_quantity * line.item_price * 100,
                                  ) / 100,
                                ).toFixed(2)
                              : null,
                        };
                      })
                      .sort((a, b) => {
                        return (
                          parseInt(`${a.item_id}`.slice(-3)),
                          invoicingSteps.linesOrder.find(
                            (line) =>
                              parseInt(line.id) ===
                              parseInt(`${a.item_id}`.slice(-3)),
                          ).order -
                            invoicingSteps.linesOrder.find(
                              (line) =>
                                parseInt(line.id) ===
                                parseInt(`${b.item_id}`.slice(-3)),
                            ).order
                        );
                      }),
                    {
                      total: <b>{subTotal.toFixed(2)}</b>,
                    },
                  ]}
                  width={
                    headerRef.current ? headerRef.current.clientWidth : 100
                  }
                />
              </div>
            </div>
          );
        })}
        <div className="newInvoicesStepsSub">
          {props.dirtyOrders.length < 1
            ? newInvoices.find((inv) => inv.id === props.subInvoices[0].id)
                .message
              ? newInvoices.find((inv) => inv.id === props.subInvoices[0].id)
                  .message
              : "."
            : props.dirtyOrders.map((order) => (
                <p className="invoiceDirtyOr">{`${order.name} - ${order.type}`}</p>
              ))}
        </div>
        {props.dirtyOrders.length > 0 ? (
          ``
        ) : (
          <button
            onClick={() => {
              if (
                !newInvoices.find((inv) => inv.id === props.subInvoices[0].id)
                  .state ||
                newInvoices.find((inv) => inv.id === props.subInvoices[0].id)
                  .state === "failed"
              ) {
                dispatch(
                  submitInvoices({
                    customer: props.twinfieldId,
                    twinfieldId: invoicingSteps.twinfieldId,
                    invoiceDate: invoicingSteps.invoicingDate,
                    invoices: props.subInvoices.map((invoice) => {
                      return {
                        invoiceId: invoice.id,
                        invoiceLines: invoice.invoiceLines.map(
                          (invoiceLine) => {
                            return {
                              invoiceLineId: invoiceLine.id,
                              invoiceType: invoiceLine.invoice_type,
                            };
                          },
                        ),
                      };
                    }),
                  }),
                );
              } else {
                console.log(props.invIndex, props.selectedInvoicesLength);
                if (
                  props.invIndex === props.selectedInvoicesLength - 1 &&
                  props.invIndex > 0
                ) {
                  dispatch(
                    setInvoicingSteps({
                      ...invoicingSteps,

                      invoiceIndex: props.invIndex - 1,
                    }),
                  );
                }
                dispatch(
                  removeInvoice({
                    invoices: props.subInvoices.map((invoice) => {
                      return {
                        invoiceId: invoice.id,
                        invoiceLines: invoice.invoiceLines.map(
                          (invoiceLine) => {
                            return {
                              invoiceLineId: invoiceLine.id,
                              invoiceType: invoiceLine.invoice_type,
                            };
                          },
                        ),
                      };
                    }),
                  }),
                );
              }
            }}
            className={"invNavMainButton"}
          >
            {!newInvoices.find((inv) => inv.id === props.subInvoices[0].id)
              .state ||
            newInvoices.find((inv) => inv.id === props.subInvoices[0].id)
              .state === "failed"
              ? "Submit"
              : "Done"}
          </button>
        )}
      </div>
    );
  } else if (
    props.customer &&
    !navigation.invoicingSubmiting &&
    props.pastInvoice
  ) {
    let invTotal = 0;
    for (let subInv of props.subInvoices) {
      let subTotal = 0;
      for (let total of subInv.invoiceLines.map((line) =>
        line.item_quantity && line.item_price
          ? parseFloat(
              parseFloat(
                Math.round(line.item_quantity * line.item_price * 100) / 100,
              ).toFixed(2),
            )
          : null,
      )) {
        subTotal = subTotal + total;
      }
      invTotal = invTotal + subTotal;
    }
    const copyStyle = (itemClass, itemId) => {
      document.getElementById(itemId).className =
        `${itemClass} invoicingCopied`;
      setTimeout(
        () => (document.getElementById(itemId).className = `${itemClass}`),
        750,
      );
    };
    return (
      <div className={"invoiceGeneralPanel oko"}>
        <div className="invoiceGeneralHeader">
          <div className={"invoicePreselectDescB invDetailsPreselectDescB"}>
            <div className={"invoicePreselectDesc1stLine"}>
              <div className="dasLine">
                <div className="dasLine">
                  Invoice number: {props.descInvoiceNr}
                </div>
              </div>
              <div className="dasLine">
                {props.agent
                  ? `Creditor's Twinfield id: ${props.twinfieldId}`
                  : `Debtor's Twinfield id: ${props.twinfieldId}`}
              </div>
            </div>
          </div>
          <div className={"invoicePreselectDescB invDetailsPreselectDescB"}>
            <div className={"invoicePreselectDesc1stLine"}>
              <div className="dasLine">
                {props.agent
                  ? `Creditor: ${props.agent} `
                  : `Debtor: ${props.customer} `}
                <img
                  alt=""
                  src={
                    props.language === "nl-NL"
                      ? netherlands
                      : props.language === "en-GB"
                        ? unitedK
                        : props.language === "de-DE"
                          ? germany
                          : ""
                  }
                  className="invoicingFlag"
                  height={"20px"}
                />
              </div>
              <div className="dasLine">{`Status: ${props.paid}`}</div>
            </div>
          </div>
          {props.generalDesc ? (
            <div className={"invoicePreselectDescB invDetailsPreselectDescB"}>
              <div className={"invoicePreselectDesc1stLine"}>
                <div className="dasLine" ref={ref} id="generalDesc">
                  {props.generalDesc}

                  <img
                    alt=""
                    src={copyIco}
                    height={"16px"}
                    onClick={(e) => {
                      copyStyle("dasLine", "generalDesc");
                      navigator.clipboard.writeText(props.generalDesc);
                    }}
                  />
                </div>
                {props.generalDesc ? (
                  <div className="dasLine">{`Total: ${props.subInvoices[0].transfer_vat ? invTotal.toFixed(2) : (invTotal * 1.21).toFixed(2)}`}</div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        {props.subInvoices.map((subInv) => {
          let subTotal = 0;
          for (let total of subInv.invoiceLines.map((line) =>
            line.item_quantity && line.item_price
              ? parseFloat(
                  parseFloat(
                    Math.round(line.item_quantity * line.item_price * 100) /
                      100,
                  ).toFixed(2),
                )
              : null,
          )) {
            subTotal = subTotal + total;
          }
          return (
            <div className={"subInvoicePanel"}>
              <div className={"invoicePreselectDescA"} id={subInv.description}>
                {subInv.description.split("\n").map((descLine, index) => {
                  if (index === subInv.description.split("\n").length - 1) {
                    return (
                      <p key={index}>
                        {descLine}
                        <img
                          src={copyIco}
                          height={"16px"}
                          alt=""
                          onClick={(e) => {
                            copyStyle(
                              "invoicePreselectDescA",
                              subInv.description,
                            );
                            navigator.clipboard.writeText(subInv.description);
                          }}
                        />
                      </p>
                    );
                  } else {
                    return <p key={index}>{descLine}</p>;
                  }
                })}
              </div>
              <div className="invoicePreselectLines" ref={headerRef}>
                <NewTable
                  tit={"invoicesPreselect"}
                  tabletype="small"
                  className="histTable"
                  data={[
                    ...subInv.invoiceLines
                      .map((line) => {
                        return {
                          ...line,
                          copy: (
                            <img
                              src={copyIco}
                              height={"16px"}
                              alt=""
                              onClick={(e) => {
                                copyStyle(
                                  "MuiTableCell-root MuiTableCell-body MuiTableCell-alignLeft MuiTableCell-sizeMedium elipsisRow css-c4wihh-MuiTableCell-root",
                                  `${line.qt_line_id}${line.item_description}`,
                                );
                                navigator.clipboard.writeText(
                                  line.item_description,
                                );
                              }}
                            />
                          ),
                          item_quantity: line.item_quantity
                            ? parseFloat(line.item_quantity).toFixed(2)
                            : null,
                          item_price: line.item_price
                            ? parseFloat(line.item_price).toFixed(2)
                            : null,
                          total:
                            line.item_quantity && line.item_price
                              ? parseFloat(
                                  Math.round(
                                    line.item_quantity * line.item_price * 100,
                                  ) / 100,
                                ).toFixed(2)
                              : null,
                        };
                      })
                      .sort((a, b) => {
                        return (
                          parseInt(`${a.item_id}`.slice(-3)),
                          invoicingSteps.linesOrder.find(
                            (line) =>
                              parseInt(line.id) ===
                              parseInt(`${a.item_id}`.slice(-3)),
                          ).order -
                            invoicingSteps.linesOrder.find(
                              (line) =>
                                parseInt(line.id) ===
                                parseInt(`${b.item_id}`.slice(-3)),
                            ).order
                        );
                      }),
                    {
                      item_unit: "Sub total",
                      item_price: " ",
                      total: <b>{subTotal.toFixed(2)}</b>,
                    },
                    {
                      item_unit: "VAT",
                      item_price: subInv.transfer_vat ? "0%" : "21%",
                      total: subInv.transfer_vat ? (
                        <b>0</b>
                      ) : (
                        <b>{(subTotal * 0.21).toFixed(2)}</b>
                      ),
                    },
                    {
                      total: subInv.transfer_vat ? (
                        <b>{subTotal.toFixed(2)}</b>
                      ) : (
                        <b>{(subTotal * 1.21).toFixed(2)}</b>
                      ),
                    },
                  ]}
                  width={
                    headerRef.current ? headerRef.current.clientWidth : 100
                  }
                />
              </div>
            </div>
          );
        })}
        {appUser.userRoles.includes("admin") ? (
          <button
            onClick={() => {
              if (navigation.invoiceCreditButton) {
                console.log("props", props.invoiceNr);
                dispatch(
                  submitCrediting({
                    invoiceNr: props.invoiceNr,
                    customer: props.twinfieldId,
                    twinfieldId: invoicingSteps.twinfieldId,
                    invoiceDate: invoicingSteps.invoicingDate,
                    invoices: props.subInvoices.map((invoice) => {
                      return {
                        invoiceId: invoice.id,
                        invoiceLines: invoice.invoiceLines.map(
                          (invoiceLine) => {
                            return {
                              invoiceLineId: invoiceLine.id,
                              invoiceType: invoiceLine.invoice_type,
                            };
                          },
                        ),
                      };
                    }),
                  }),
                );
              }
            }}
            className={
              navigation.invoiceCreditButton
                ? "invNavMainButton"
                : "invNavMainButton inactiveButton"
            }
          >
            Credit
          </button>
        ) : (
          ""
        )}
      </div>
    );
  } else {
    return <div></div>;
  }
};
export const MemoPanelComponent = memo(PanelComponent);
